"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumb = Breadcrumb;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    .wrapper {\n        text-decoration: none;\n        &:visited {\n            color: inherit;\n        };\n        &:hover {\n            color: ", ";\n        };\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-left: ", "px;\n    display:inline-block;\n    color: ", ";\n    :not(:first-child):before {\n        content: '/';\n        margin-right: ", "px;\n    };\n    :last-child {\n        color: ", ";\n        cursor: default;\n    };\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["    \n    font-size: ", "rem;    \n    font-family: ", ";\n    padding-left: 0px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BreadcrumbWrapper = _styledComponents["default"].ul(_templateObject(), function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.fontFamilyObj;
});

var BreadcrumbItemWrapper = _styledComponents["default"].li(_templateObject2(), function (props) {
  return props.spacingObj.margin;
}, function (props) {
  return props.colorObj.linkColor;
}, function (props) {
  return props.spacingObj.margin;
}, function (props) {
  return props.activeColor;
});

var LinkWrapper = _styledComponents["default"].span(_templateObject3(), function (props) {
  return props.colorObj.hoverColor;
});
/**
 * The Breadcrumb component is used to trace a users' path to the current page.
 * @example import { Breadcrumb } from '@desktop/react';
 */


function Breadcrumb(props) {
  var inherit = 'breadcrumb';
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit];
  var colors = context.getColors()[inherit];
  var items = [];
  var activeColor = props.activeColor ? props.activeColor : colors.activeColor;
  props.children.map(function (item, index) {
    var active = index === props.children.length - 1 ? true : false;
    items.push(active ? /*#__PURE__*/_react["default"].createElement(BreadcrumbItemWrapper, {
      key: "item " + index,
      style: item.props.style,
      spacingObj: spacing,
      colorObj: colors,
      activeColor: activeColor
    }, item.props.label) : /*#__PURE__*/_react["default"].createElement(BreadcrumbItemWrapper, {
      key: "item " + index,
      style: item.props.style,
      spacingObj: spacing,
      colorObj: colors
    }, /*#__PURE__*/_react["default"].createElement(LinkWrapper, {
      colorObj: colors
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      className: "wrapper",
      to: item.props.link
    }, item.props.label)))));
  });
  return /*#__PURE__*/_react["default"].createElement(BreadcrumbWrapper, {
    style: props.style,
    spacingObj: spacing,
    fontFamilyObj: context.getFont()
  }, items);
}

Breadcrumb.propTypes = {
  /**The items in the breadcrumb. Each item must be represented by an 'Item' component.
   * Each 'Item' element can has 'label', 'link' and 'style' props.
  */
  children: _propTypes["default"].node.isRequired,

  /** Extends the base styling of the breadcrumb element.*/
  style: _propTypes["default"].object,

  /**Overrides the text color of the active breadcrumb item. */
  activeColor: _propTypes["default"].string
};
Breadcrumb.defaultProps = {
  style: {},
  activeColor: null
};